
<div v-if="item.plannedDate">
  <i class="far fa-clock" v-b-tooltip.hover.top :title="formattedDate" ></i>
</div>
